import { Injectable } from '@angular/core';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { Color, ClaimService, Icons } from '@lsq-frontend/common-ui';
import { map } from 'rxjs/operators';
import { WhiteLabelRule } from '../white-label-rule';

@Injectable()
export class SupplyChainDirectWhiteLabelRule implements WhiteLabelRule {
    public whiteLabelRule$ = this._claimService.claimStream.pipe(
        map((claims) => {
            const isScfSeller = claims[DashboardClaim.FinancingVendorPortal];
            const isScfBuyer = claims[DashboardClaim.FinancingBuyerPortal];
            if (isScfSeller || isScfBuyer) {
                return {
                    scfPlatformProductName: 'FastTrack',
                    scfPlatformPlatformName: 'LSQ',
                    whiteLabelClassName: undefined,
                    navbarCoBrandLogoAssetPath: undefined,
                    navbarCoBrandStackedLogoAssetPath: undefined,
                    navbarMainBrandLogoIconConfig: {
                        type: Icons.FastTrackLogo,
                        color: Color.Black
                    }
                };
            }
            return {};
        })
    );

    constructor(private _claimService: ClaimService) {}
}
